var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect } from "react";
import { fetchImportProgress, } from "../api/authorityImportService";
import { useStableOkapiKy } from "./useStableOkapiKy";
var POLL_INTERVAL = 2000;
var STORAGE_KEY_PREFIX = "import-progress-";
var isTerminal = function (status) {
    return status === "COMPLETED" || status === "FAILED";
};
var getCachedProgress = function (importId) {
    try {
        var cached = sessionStorage.getItem(STORAGE_KEY_PREFIX + importId);
        return cached ? JSON.parse(cached) : null;
    }
    catch (_a) {
        return null;
    }
};
var cacheProgress = function (importId, data) {
    try {
        sessionStorage.setItem(STORAGE_KEY_PREFIX + importId, JSON.stringify(data));
    }
    catch (_a) {
        // ignore storage errors
    }
};
/**
 * Tracks the progress of an authority import.
 *
 * A finished import (COMPLETED/FAILED) cached in sessionStorage is shown
 * without any request. Otherwise the status is polled: the first request goes
 * out immediately, every next one {@link POLL_INTERVAL} ms after the previous
 * answer arrived — so there is never more than one request in flight and never
 * more than one per interval. Polling stops for good on a terminal status or an
 * error, and a late answer for a previous import id is ignored.
 */
export var useImportProgress = function (importId) {
    var kyInstance = useStableOkapiKy();
    var _a = useState(null), progress = _a[0], setProgress = _a[1];
    useEffect(function () {
        if (!importId) {
            setProgress(null);
            return undefined;
        }
        var cached = getCachedProgress(importId);
        setProgress(cached);
        if (cached && isTerminal(cached.status)) {
            return undefined;
        }
        var cancelled = false;
        var timer = null;
        var poll = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetchImportProgress(kyInstance, importId)];
                    case 1:
                        data = _a.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        setProgress(data);
                        if (isTerminal(data.status)) {
                            cacheProgress(importId, data);
                            return [2 /*return*/];
                        }
                        timer = setTimeout(poll, POLL_INTERVAL);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        console.error("Error polling import progress:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        poll();
        return function () {
            cancelled = true;
            if (timer)
                clearTimeout(timer);
        };
    }, [importId, kyInstance]);
    return progress;
};
